// extracted by css-extract-rspack-plugin
export default {"zoom":"Zoom-module__zoom___MVuFV","max":"Zoom-module__max___TclAp","warning":"Zoom-module__warning___R65_o"};